import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelDetails } from 'src/app/common/interfaces/home/side-panel-details.interface';
import { Router } from '@angular/router';
import { DiscrepanciesComponent } from './discrepancies/discrepancies.component';
import { SidePanelFilterComponent } from './side-panel-filter/side-panel-filter.component';
import { SidePanelTableDataComponent } from './side-panel-table-data/side-panel-table-data.component';
import { MDSignatureComponent } from "./mdsignature/mdsignature.component";

@Component({
  selector: 'app-side-panel',
  standalone: true,
  imports: [
    CommonModule,
    DiscrepanciesComponent,
    SidePanelFilterComponent,
    SidePanelTableDataComponent,
    MDSignatureComponent
],
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  @Input() panelDetails!: SidePanelDetails;
  @Output() closed = new EventEmitter<boolean>();
  showFilters: boolean = false;

  constructor(private router: Router) {}
  
  navigate(route: string) {
    this.router.navigateByUrl(route);
  }
  
  isShowFilters(){
    this.showFilters = !this.showFilters;
  }
}
